// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Q4ZpE","rootNoMargin":"styles_rootNoMargin__3lVXC"};